export default function sortChecker(params?: { sort?: string[] }) {
  // if sort has empty array or undefined or null, remove sort from params
  if (params && (!params.sort || params.sort.length === 0)) {
    delete params.sort
  }
  return params
}
